export enum ZIndex {
  TABLE_HEADER = 1,
  TABLE_FILTER = 2,
  MOBILE_MENU_OVERLAY = 10,
  MOBILE_MENU = 11,
  SPLASH = 12,
}
